import { LAMINATE_REGEX } from '~/core/constants/materialType';
import { SideItemType } from '~/core/enums';

export const SIDE_ITEM_TYPE_MATERIAL_MAP: Record<SideItemType, RegExp | null> =
  {
    [SideItemType.WALL_SIDE]: null,
    [SideItemType.APPLIANCE_SIDE]: null,
    [SideItemType.WATERFALL]: null,
    [SideItemType.END_CAP]: LAMINATE_REGEX,
    [SideItemType.END_SPLASH]: LAMINATE_REGEX,
  };
